// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightAssinaturaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /migration/assinaturas/preflight?zoho_id_unidade=
 * (controllers/migration/assinaturas.php::preflight).
 *
 * So a franquia. A E9 nao tem corte de data: o historico de cobranca inteiro
 * interessa — e a sequencia de falhas que explica atraso e cancelamento.
 *
 * Tipo ESTRITO pelo motivo de sempre: o id da unidade tem 19 digitos e e
 * MAIOR que 2^53 — um numero JSON aqui ja chegaria corrompido (armadilha A1).
 */
import { registerContract } from './validate'

export interface Migration_PreflightAssinaturaInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_PreflightAssinaturaInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
